<template>
  <div class="change">
    <div
      class="alsrtInfo"
      :style="{display: displayStsates}"
      ref="alertMsg"
    >
      <div class="profPrompt_test">{{aletMsg}}</div>
    </div>
    <div class="change_nav">
      <img
        @click="_return()"
        src="../../images/lujing.png"
        alt
      />
      <h4>修改密码</h4>
    </div>
    <ul class="change_content">
      <li>
        <span>原密码</span>
        <input
          maxlength="12"
          v-model:value="original_ps"
          @input="rule()"
          type="text"
          placeholder="请输入..."
        />
      </li>
      <li v-if="top_show">
        <span>新密码</span>
        <input
          type="password"
          v-model:value="new_ps_top"
          maxlength="12"
          placeholder="请输入新密码"
        />
        <img
          v-on:click="top_show = !top_show"
          id="top_show"
          src="../../images/hb6.png"
        />
      </li>
      <li v-if="!top_show">
        <span>新密码</span>
        <input
          type="text"
          @input="rule()"
          v-model:value="new_ps_top"
          maxlength="12"
          placeholder="请输入新密码"
        />
        <img
          v-on:click="top_show = !top_show"
          id="bottom_hide"
          src="../../images/high_yj.png"
        />
      </li>
      <li v-if="bottom_show">
        <span>确认新密码</span>
        <input
          type="password"
          v-model:value="new_ps_bottom"
          maxlength="15"
          placeholder="请确认新密码"
        />
        <img
          v-on:click="bottom_show = !bottom_show"
          id="top_show"
          src="../../images/hb6.png"
        />
      </li>
      <li v-if="!bottom_show">
        <span>确认新密码</span>
        <input
          type="text"
          v-model:value="new_ps_bottom"
          @input="rule()"
          maxlength="12"
          placeholder="请确认新密码"
        />
        <img
          v-on:click="bottom_show = !bottom_show"
          id="bottom_hide"
          src="../../images/high_yj.png"
        />
      </li>
    </ul>
    <p
      v-on:click="login()"
      id="save"
    >保存修改</p>
  </div>
</template>
<script>
import API from "../../lmj_Api/api";
export default {
  name: 'GoodsChangePass',
  data () {
    return {
      uid: this.$store.getters.get_user_id,
      top_show: true,
      bottom_show: true,
      original_ps: "",
      new_ps_top: "",
      new_ps_bottom: "",
      aletMsg: "",
      displayStsates: "none",


    };
  },
  methods: {
    login () {
      var that = this;
      if (this.original_ps == '' || this.new_ps_top == "" || this.new_ps_bottom == "") {
        this.alertDia('必填项还未填写');
      } else {
        if (this.original_ps.length < 6 || this.new_ps_top.length < 6 || this.new_ps_bottom.length < 6) {
          this.alertDia('密码限制6-12位');
          return;
        }
        if (this.new_ps_top != this.new_ps_bottom) {
          this.alertDia('新密码不一致');
          return;
        }
        var url = API.passEdit;
        var _data = {
          user_id: that.uid,
          password: that.original_ps,
          newpassword: that.new_ps_top,
          newspassword: that.new_ps_bottom
        };
        that.axios
          .post(url, _data)
          .then((res => {
            console.log(res)
            if (res.data.code == 200) {
              this.alertDia("修改成功");
              window.setTimeout(() => {
                this.$router.push({ path: '/' });
              }, 1100)
              return;
            } else {
              this.alertDia(res.data.msg);
              return;
            }
          }))
          .catch((error => {
            console.log(error)
          }))
      }
    },
    alertDia (msg) {
      this.displayStsates = "block";
      this.aletMsg = msg;
      window.setTimeout(() => {
        this.displayStsates = "none";
      }, 1200);
    },
    rule () {
      if (this.original_ps != "") {
        this.original_ps = this.original_ps.replace(/[\u4e00-\u9fa5]/g, "");
      }
      if (this.new_ps_top != "") {
        this.new_ps_top = this.new_ps_top.replace(/[\u4e00-\u9fa5]/g, "");
      }
      if (this.new_ps_bottom != "") {
        this.new_ps_bottom = this.new_ps_bottom.replace(/[\u4e00-\u9fa5]/g, "");
      }
    },

    _return () {
      this.$router.go(-1);
    }
  },
  props: ['getId'],//接手id

};
</script>
<style lang="less" scoped>
div,
p,
ul,
li,
a,
h4,
img {
  padding: 0;
  margin: 0;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.change {
  .change_nav {
    background: linear-gradient(
      90deg,
      rgba(123, 212, 255, 1) 0%,
      rgba(92, 186, 255, 1) 100%
    );
    line-height: 0.88rem;
    height: 0.88rem;
    width: 7.5rem;
    text-align: center;
    position: relative;
    img {
      height: 0.34rem;
      position: absolute;
      left: 0.44rem;
      top: 0.26rem;
    }
    h4 {
      width: 100%;
      color: white;
      font-size: 0.3rem;
      font-family: PingFangSC-Medium, sans-serif;
      font-weight: 500;
    }
  }
  .change_content {
    padding: 0 0.4rem;
    margin: 0;
    li {
      font-size: 0.3rem;
      line-height: 1rem;
      height: 1.02rem;
      width: 6.72rem;
      border-bottom: 1px solid #eee;
      position: relative;
      span {
        display: inline-block;
        width: 27%;
        font-size: 0.3rem;
      }
      input {
        border: 0px;
        height: 0.7rem;
        font-size: 0.24rem;
        line-height: 0.4rem;
        width: 4rem;
      }
      img {
        position: absolute;
        right: 0.3rem;
        top: 0.32rem;
      }
      #top_show {
        width: 0.46rem;
      }
      #bottom_hide {
        width: 0.46rem;
      }
    }
  }
  #save {
    background: linear-gradient(
      90deg,
      rgba(123, 212, 255, 1) 0%,
      rgba(92, 186, 255, 1) 100%
    );
    text-align: center;
    line-height: 1.08rem;
    height: 1.08rem;
    color: white;
    margin: 0;
    font-size: 0.3rem;
    position: fixed;
    width: 7.5rem;
    bottom: 0;
  }

  //提示框
  .alsrtInfo {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    .profPrompt_test {
      width: 4.2rem;
      height: 1.4rem;
      line-height: 1.4rem;
      border-radius: 0.2rem;
      color: #fff;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.6);
      opacity: 0.6;
      top: 5.98rem;
      left: 50%;
      font-size: 0.28rem;
      font-family: Gotham-Book;
      opacity: 1;
      text-align: center;
      transform: translate(-50%, -50%);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GoodsEnter/ChangePass.vue